export const normalizeScorLineBreaks = (text: string): string =>
  text.replace(/\\r\\n|\\r|\\n|\r\n?/g, '\n');
